import { EmailVarification } from './features/auth/pages/email-varification/email-varification';
import { ChangePassword } from './features/auth/pages/change-password/change-password';
import { ForgotPassword } from './features/auth/pages/forgot/forgot-password';
import { MainLayout } from './layout/main-layout/main-layout';
import { AuthLayout } from './layout/auth-layout/auth-layout';
import { Profile } from './features/profile/pages/profile';
import { SignUp } from './features/auth/pages/signup/sign-up';
import { Login } from './features/auth/pages/login/login';
import { Routes } from '@angular/router';
import { workspaceGuard } from './features/workspace/guards/workspace-guard';
import { publicGuard } from './features/workspace/guards/public-guard';
import { authGuard } from './features/auth/guards/auth-guard';
import { Page404 } from './shared/components/page-404/page-404';
import { environment } from '../environments/environment';
import { AcceptInvitation } from './features/auth/pages/accept-invitation/accept-invitation';

export const routes: Routes = [
  { path: '', redirectTo: 'workspace/choose', pathMatch: 'full' },
  {
    path: '',
    component: AuthLayout,
    children: [
      {
        path: 'login', component: Login, canActivate: [publicGuard],
        data: { routeTitle: environment.app_title + ' - Login' }
      },
      {
        path: 'signup', component: SignUp, canActivate: [publicGuard],
        data: { routeTitle: environment.app_title + ' - Sign Up' }
      },
      {
        path: 'reset-password', component: ChangePassword, canActivate: [publicGuard],
        data: { routeTitle: environment.app_title + ' - Reset Password' }
      },
      {
        path: 'forgot-password', component: ForgotPassword, canActivate: [publicGuard],
        data: { routeTitle: environment.app_title + ' - Forgot Password' }
      },
      {
        path: 'email-verified', component: EmailVarification, canActivate: [publicGuard],
        data: { routeTitle: environment.app_title + ' - Email Verification' }
      },
      {
        path: 'accept-invitation', component: AcceptInvitation,
        data: { routeTitle: environment.app_title + ' - Accept Invitation' }
      },
      {
        path: 'workspace',
        loadChildren : () => import('./features/workspace/routes/workspace.routes').then(m => m.WORKSPACE_ROUTES),
      },
    ],
  },
  {
    path: 'workspace/:id',
    loadChildren : () => import('./features/workspace/routes/workspace-app.routes').then(m => m.WORKSPACE_APP_ROUTES),
  },
  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard, workspaceGuard],
    children: [
      { path: 'profile', component: Profile, data: { routeTitle: environment.app_title + ' - Profile' } },

    ]
  },
  { path: '**', component: Page404, data: { routeTitle: environment.app_title + ' - 404' } },
];
